import React from 'react';
import moment from 'moment-business-days';
import styled from 'styled-components';
import validator from 'validator';
import { Translation } from 'react-i18next';
import { extendMoment } from 'moment-range';
import { renderToString } from 'react-dom/server';
import { PageNavigator, ShortPageNavigator } from 'oxyrion-ui/lib';
import baseTheme from 'oxyrion-ui/lib/Themes/baseTheme';
import { rem } from 'polished';
import { Link } from 'react-router-dom';
import { RouteLinkWraper, IFrame } from '../Components/ReusableComponents';
// import MailLink from '../Components/MailLink';

const Moment = extendMoment(moment);

export const FORMAT_HUMANE_DATETIME = 'DD.MM.YYYY HH:mm';
export const FORMAT_HUMANE_DATE = 'DD.MM.YYYY';
export const FORMAT_HUMANE_TIME = 'HH.mm';
export const SK_PHONE_PREFIX = '+421';
export const CZ_PHONE_PREFIX = '+420';
export const LOCALE = ['sk-SK', 'cs-CZ'];

export const __e = text => {
  // vrati preklad ako react elemnt
  return (
    <Translation>
      {t => {
        return t(text) || `${text}`;
      }}
    </Translation>
  );
};

export const __ = text => {
  // vrati preklad ako string
  return renderToString(__e(text));
};

export const formatPhoneNumber = (phone, firm) => {
  if (phone.startsWith(0)) {
    const c = phone.split(' ').join('');
    const formatedPhone = c.replace(/(\d{1})(\d{3})(\d{3})(\d{3})/, '$2 $3 $4');
    switch (firm) {
      case 'SK':
        return `${SK_PHONE_PREFIX} ${formatedPhone}`;
      case 'CZ':
        return `${CZ_PHONE_PREFIX} ${formatedPhone}`;
      default:
        return phone;
    }
  }
  return phone;
};

export const parseHash = hash => {
  let content = hash;
  if (hash.indexOf('#') >= 0) {
    content = hash.substring(hash.indexOf('#') + 1);
  }
  const result = content.split('&').reduce((acum, item) => {
    const [key, value] = item.split('=');
    const r = Object.assign({}, acum);
    r[key] = value;
    return r;
  }, {});

  return result;
};

export const formatNumber = (n, c = 2, d = ',', t = ' ') => {
  const s = n < 0 ? '-' : '';
  const b = Math.abs(+n || 0);
  const i = String(parseInt(b.toFixed(c), 10));
  let j = i.length;
  j = j > 3 ? j % 3 : 0;

  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) +
    (c
      ? d +
        Math.abs(b - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
};

export function round(number, precision) {
  const factor = 10 ** precision;
  const tempNumber = number * factor;
  const roundedTempNumber = Math.round(tempNumber);
  return roundedTempNumber / factor;
}

export const formatNumberTo148YUS = value => {
  const yValue = Math.floor(value / 48);
  return `${yValue > 0 ? `${yValue}Y +` : ''} ${formatNumber(value % 48, 3)}`;
};

export const handleServiceStataus = status => {
  switch (status) {
    case 'new':
      return __('Nová');
    case 'solved':
      return __('Vyriešená');
    case 'confirmed':
      return __('Potvrdená');
    case 'closed':
      return __('Uzavretá');
    default:
      return status;
  }
};

export const formatPrice = (
  { amount, currency = 'EUR' },
  c = 2,
  d = ',',
  t = '\u00a0',
) => {
  const a = Number(`${Math.round(Number(`${amount}e${c}`))}e-${c}`);
  if (currency === 'CZK') {
    return `${formatNumber(a, c, d, t, c)}\u00a0Kč`;
  } else if (currency === 'EUR') {
    return `${formatNumber(a, c, d, t, c)}\u00a0€`;
  }
  return `${formatNumber(a, c, d, t, c)}\u00a0${currency}`;
};

export const redirect = redirectUrl => {
  window.location.href = redirectUrl;
};

export const handlePriceForTable = priceData => {
  if (!priceData) {
    return null;
  }
  return formatPrice(priceData);
};

export const formatDate = (date, format = FORMAT_HUMANE_DATE) => {
  return moment.isMoment(date) ? moment(date).format(format) : '';
};

export const getMonthByNumber = number => {
  switch (number) {
    case 1:
      return __('Január');
    case 2:
      return __('Február');
    case 3:
      return __('Marec');
    case 4:
      return __('Apríl');
    case 5:
      return __('Máj');
    case 6:
      return __('Jún');
    case 7:
      return __('Júl');
    case 8:
      return __('August');
    case 9:
      return __('September');
    case 10:
      return __('Október');
    case 11:
      return __('November');
    case 12:
      return __('December');
    default:
      return number;
  }
};

export const formatProbability = value => {
  switch (value) {
    case 'Low':
      return __('Nízka');
    case 'Medium':
      return __('Stredná');
    case 'High':
      return __('Vysoká');
    default:
      return value;
  }
};

export const toIsoDate = s => {
  return moment(s, FORMAT_HUMANE_DATE).toISOString();
};

export const renderLink = (to, name, noMargin = true, fontSize = rem(11)) => {
  return (
    <RouteLinkWraper fontSize={fontSize} noMargin={noMargin}>
      <Link to={to}>{name}</Link>
    </RouteLinkWraper>
  );
};

export const defaultCustomertype = values => {
  if (values && values.length) {
    return `${values[0].type} - ${values[0].subtype}`;
  }
  return '';
};

export const formatStatus = value => {
  switch (value) {
    case 'active':
      return __('Aktívny');
    case 'inactive':
      return __('Neaktívny');
    default:
      return value;
  }
};

export const normalizeAddressData = data => {
  if (!data) {
    return [];
  }

  const address = [
    {
      name: __('Krajina'),
      value: data.country,
    },
    {
      name: __('Mesto'),
      value: data.city,
    },
    {
      name: __('Ulica'),
      value: data.street,
    },
    {
      name: __('Poštové číslo'),
      value: data.postal_code,
    },
  ];
  return address;
};

export const getAddressLabel = data => {
  if (data) {
    return `${data.street && `${data.street}, `}${data.postal_code &&
      data.postal_code}`;
  }
  return '';
};

export const normalizeFirmInfoData = (
  data,
  handleNameOnClick = undefined,
  path,
) => {
  if (!data) {
    return [];
  }

  const firmInfo = [
    {
      name: __('Meno'),
      value: path
        ? renderLink(`${path}/${data._id}`, data.name, true)
        : data.name,
      handleOnClick: handleNameOnClick && (() => handleNameOnClick(data._id)),
    },
    {
      name: __('Email'),
      // Component: () => <MailLink mail={data.email} />,
    },
    {
      name: __('IČO'),
      value: data.registration_no,
    },
    {
      name: __('Vlastník'),
      value: data.ownership
        ? data.ownership.map(o => o.display_name).join(', ')
        : '-',
    },
    {
      name: __('Kategória segmentu'),
      value: data.segment_category,
      hidden: true,
    },
  ];
  return firmInfo;
};

export const normalizeCustomerBasicInfo = (data, address) => {
  const addressData = !address ? [] : normalizeAddressData(address);
  const basicData = !data ? [] : normalizeFirmInfoData(data, null, null);
  return [
    ...basicData.filter(
      f => f.name !== __('IČO') && f.name !== __('Kategória segmentu'),
    ),
    ...addressData,
    ...basicData.filter(f => f.name === __('IČO')),
    ...basicData.filter(f => f.name === __('Kategória segmentu')),
  ];
};

export const narmalizeOpportunities = (
  opportunities,
  handleOpportunityOnClick,
  path,
) => {
  if (!opportunities) {
    return [];
  }
  return opportunities.reduce((acumulator, item) => {
    const row = [
      {
        value: item.topic,
        handleOnClick: handleOpportunityOnClick
          ? () => handleOpportunityOnClick(item._id)
          : null,
        path: path ? `${path}/${item._id}` : null,
      },
      {
        value: item.status,
      },
      {
        value: formatDate(item.actual_date),
      },
      {
        value: formatPrice(item.actual_profit),
      },
      {
        value: formatDate(item.estimated_date),
      },
      {
        value: formatPrice(item.estimated_profit),
      },
    ];
    acumulator.push(row);
    return acumulator;
  }, []);
};

export const normalizeActivities = (
  activities,
  handleActivityOnClcik = null,
  path = null,
) => {
  if (!activities) {
    return [];
  }

  return activities.reduce((acumulator, item) => {
    const row = [
      {
        value: moment(item.to_date).format(FORMAT_HUMANE_DATETIME),
      },
      {
        value: item.subject,
        handleOnClick: handleActivityOnClcik
          ? () => handleActivityOnClcik(item._id)
          : null,
        path: path ? `${path}/${item._id}` : null,
      },
      {
        value: item.user_name || '_',
      },
      {
        value: item.summary || '_',
      },
    ];
    acumulator.push(row);
    return acumulator;
  }, []);
};

export const normalizeTasks = (tasks, handleTaskOnClick, path) => {
  if (!tasks) {
    return [];
  }
  return tasks.reduce((acumulator, item) => {
    const row = [
      {
        value: formatDate(item.date),
      },
      {
        value: item.subject,
        handleOnClick: handleTaskOnClick
          ? () => handleTaskOnClick(item._id)
          : null,
        path: path ? `${path}/${item._id}` : null,
      },
      {
        value: moment(item.from_date).format(FORMAT_HUMANE_DATE),
      },
      {
        value: moment(item.to_date).format(FORMAT_HUMANE_DATE),
      },
    ];
    acumulator.push(row);
    return acumulator;
  }, []);
};

export const normalizeContactInfoData = (data, firm = 'CZ') => {
  if (!data) {
    return [];
  }
  return [
    {
      name: __('Meno'),
      value: data.name,
    },
    {
      name: __('Priezvisko'),
      value: data.surname,
    },
    {
      name: __('Pracovná pozícia'),
      value: data.position,
    },
    {
      name: __('Email'),
      // Component: () => <MailLink mail={data.email} />,
    },
    {
      name: __('Mobil'),
      value: data.mobile,
    },
    {
      name: __('Telefón'),
      value: formatPhoneNumber(data.phone, firm),
    },
    {
      name: __('Web'),
      value: data.web,
    },
    {
      name: __('Vlastník'),
      value: data.ownership
        ? data.ownership.map(e => e.display_name).join(', ')
        : '-',
    },
  ];
};

export const normalizeContactsPersonalData = data => {
  if (!data) {
    return [];
  }

  return [
    {
      name: __('Pohlavie'),
      value:
        (data.sex === 'M' && __('Muž')) || (data.sex === 'F' && __('Žena')),
    },
    {
      name: __('Narodeniny'),
      value: data.birthdate && formatDate(data.birthdate),
    },
  ];
};

export const formatActivityBody = body => {
  const match = /<body>\r\n(.*)/;
  return body.match(match) ? body.match(match)[1] : '';
};

export const formatImportance = importance => {
  switch (importance) {
    case 'low':
      return __('Nízka');
    case 'normal':
      return __('Normálna');
    case 'high':
      return __('Vysoká');
    default:
      return importance;
  }
};

export const injectStyleToIframeBody = (styles, htmlContent) => {
  if (htmlContent) {
    const match = htmlContent.match('<body>');

    if (match) {
      const array = htmlContent.split('');
      array.splice(match.index + 5, 0, ` style="${styles}"`);
      return array.join('');
    }
  } else {
    return htmlContent;
  }
  return htmlContent;
};

export const normalizeCalendarEventData = data => {
  if (!data) {
    return [];
  }

  return [
    {
      name: __('Názov'),
      value: data.subject,
    },
    {
      name: __('Popis'),
      Component: () => (
        <React.Fragment>
          <IFrame
            title="body"
            srcDoc={injectStyleToIframeBody(
              `font-size: ${rem(11)}; font-family: ${
                baseTheme.fontFamily
              }; margin: ${rem(5)} 0; color: ${baseTheme.textColor}`,
              data.body,
            )}
          />
        </React.Fragment>
      ),
    },
    {
      name: __('od'),
      value: data.from_date
        ? moment(data.from_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Do'),
      value: data.to_date
        ? moment(data.to_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Priorita'),
      value: formatImportance(data.priority),
    },
    {
      name: __('Zrušená'),
      value: data.is_cancelled ? __('áno') : __('nie'),
    },
    {
      name: __('Vytvorená'),
      value: data.created_date
        ? moment(data.created_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Upravená'),
      value: data.updated_date
        ? moment(data.updated_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Zákazník'),
      value: data.customer_name,
    },
  ];
};

export const normalizeActivityData = data => {
  if (!data) {
    return [];
  }

  return [
    {
      name: __('Názov'),
      value: data.subject,
    },
    {
      name: __('Popis'),
      value: data.body,
    },
    {
      name: __('od'),
      value: data.from_date
        ? moment(data.from_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Do'),
      value: data.to_date
        ? moment(data.to_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Priorita'),
      value: formatImportance(data.priority),
    },
    {
      name: __('Zrušená'),
      value: data.is_cancelled ? __('áno') : __('nie'),
    },
    {
      name: __('Vytvorená'),
      value: data.created_date
        ? moment(data.created_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Upravená'),
      value: data.updated_date
        ? moment(data.updated_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Zákazník'),
      value: data.customer_name,
    },
  ];
};

export const normalizeTaskData = data => {
  if (!data) {
    return [];
  }

  return [
    {
      name: __('Názov'),
      value: data.subject,
    },
    {
      name: __('Dôležitosť'),
      value: formatImportance(data.importance),
    },
    {
      name: __('Od'),
      value: data.start_date
        ? moment(data.start_date).format(FORMAT_HUMANE_DATE)
        : '',
    },
    {
      name: __('Do'),
      value: data.due_date
        ? moment(data.due_date).format(FORMAT_HUMANE_DATE)
        : '',
    },
    {
      name: __('Vytvorená'),
      value: data.created_date
        ? moment(data.created_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Upravená'),
      value: data.updated_date
        ? moment(data.updated_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Dokončená'),
      value: data.completed_date
        ? moment(data.completed_date).format(FORMAT_HUMANE_DATETIME)
        : '',
    },
    {
      name: __('Zákazník'),
      value: data.customer_name,
    },
  ];
};

export const normalizeLeads = (leads, path) => {
  if (!leads) {
    return [];
  }
  return leads.map(item => [
    {
      value: item.name,
      path: `${path}${item._id}`,
    },
    {
      value: item.estimated_revenue ? formatPrice(item.estimated_revenue) : '',
    },
    {
      value: formatProbability(item.probability),
    },
    {
      value: item.revenue ? formatPrice(item.revenue) : '',
    },
    {
      value: item.profit ? formatPrice(item.profit) : '',
    },
    {
      value: item.billing_address ? item.billing_address.city : '',
    },
    {
      value:
        item.crm_type && item.crm_type.length
          ? defaultCustomertype(item.crm_type)
          : '',
    },
  ]);
};

export const normalizeServices = (services, handleServiceOnClick, path) => {
  if (!services) {
    return [];
  }

  return services.reduce((acumulator, item) => {
    const row = [
      {
        value: formatDate(item.date),
      },
      {
        value: item.name,
        handleOnClick: handleServiceOnClick
          ? () => handleServiceOnClick(item._id)
          : null,
        path: path ? `${path}/${item._id}` : null,
      },
      {
        value: item.user_name || __('Nezadaný'),
      },
      {
        value: handleServiceStataus(item.status),
      },
      {
        value: item.updated_date
          ? formatDate(item.updated_date, FORMAT_HUMANE_DATETIME)
          : '',
      },
    ];
    acumulator.push(row);
    return acumulator;
  }, []);
};
export const getContactFullName = contact => {
  if (contact) {
    const restNames = [];
    if (contact.name && contact.name !== '') {
      restNames.push(contact.name);
    }
    if (contact.surname && contact.surname !== '') {
      restNames.push(contact.surname);
    }
    return restNames.join(' ');
  }
  return null;
};

export const isEmptyValidation = {
  validate: value => validator.isEmpty(String(value)),
  validWhen: false,
  errorMessage: __('Nevyplnená hodnota'),
};

export const isEmailValidation = {
  validate: value => validator.isEmail(value),
  validWhen: true,
  errorMessage: __('Nesprávne zadaný email'),
};

export const isNotNullEmailValidation = {
  validate: value =>
    !validator.isEmpty(value) ? validator.isEmail(value) : true,
  validWhen: true,
  errorMessage: __('Nesprávne zadaný email'),
};

export const isPhoneValidation = {
  validate: value =>
    validator.isMobilePhone(value, LOCALE, { strictMode: true }),
  validWhen: true,
  errorMessage: __('Nesprávne zadané telefónne čislo'),
};

export const isNotNullPhoneValidation = {
  validate: value =>
    !validator.isEmpty(value)
      ? validator.isMobilePhone(value, LOCALE, { strictMode: true })
      : true,
  validWhen: true,
  errorMessage: __('Nesprávne zadané telefónne čislo'),
};

// format DD.MM.YYYY
export const isDateValidation = {
  validate: value =>
    value.match(
      /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/,
    ),
  validWhen: !null,
  errorMessage: __('Nesprávne zadaný dátum'),
};

export const isMomentDateValidation = {
  validate: value => value && value.isValid(),
  validWhen: true,
  errorMessage: __('Nesprávne zadaný dátum'),
};

// format DD.MM.YYYY
export const isNotNullDateValidation = {
  validate: value =>
    !validator.isEmpty(value)
      ? value.match(
          /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/,
        )
      : true,
  validWhen: !null,
  errorMessage: __('Nesprávne zadaný dátum'),
};

export const isNumberValidation = {
  validate: value => validator.isNumeric(String(value)),
  validWhen: true,
  errorMessage: __('Nesprávne zadaná číselná hodnota'),
};

export const isNumberGreaterThanZeroValidation = {
  validate: value => validator.isNumeric(String(value)) && value > 0,
  validWhen: true,
  errorMessage: __('Nesprávne zadaná číselná hodnota'),
};

export const validateFormItems = items => {
  const newErrors = [];
  const data = items.map(item => {
    if (item.validation) {
      const e = item.validation.reduce((acumulator, validators) => {
        if (item.notRequired && (item.value === '' || item.value === null)) {
          return acumulator;
        }
        if (!validators.validate(item.value) === validators.validWhen) {
          acumulator.push(validators.errorMessage);
          return acumulator;
        }
        return acumulator;
      }, []);

      if (e.length) {
        for (let i = 0; i < e.length; i++) {
          if (!newErrors.includes(e[i])) {
            newErrors.push(e[i]);
          }
        }
        return { ...item, error: true };
      }
      return { ...item, error: false };
    }
    return item;
  });
  return [newErrors, data];
};

export const getFirmPrice = (firm, value) => {
  const d = {
    amount: value ? Number(value) : 0,
  };
  if (firm === 'CZ') {
    return Object.assign({}, d, { currency: 'CZK' });
  }

  return Object.assign({}, d, { currency: 'EUR' });
};

export const buildQuery = query => {
  const keys = Object.keys(query);
  const queryItems = keys.reduce((acum, key) => {
    const q = `${key}=${query[key]}`;
    acum.push(q);
    return acum;
  }, []);
  return queryItems.join('&');
};

export const parseQuery = query => {
  let q;
  if (query.startsWith('?')) {
    q = query.slice(1);
  } else {
    q = query;
  }
  const separated = q.split('&');
  const result = separated.reduce((acum, item) => {
    const splitted = item.split('=');
    if (!splitted.length || splitted.length !== 2) {
      return acum;
    }
    const [name, value] = splitted;
    return { ...acum, [name]: value };
  }, {});

  return result;
};

export const getRangeOfDates = (
  start,
  end,
  key = 'day',
  format = 'YYYY-MM-DD',
) => {
  const startMoment = moment(start);
  const endMoment = moment(end);
  if (endMoment.diff(startMoment) < 0) return [];

  return Array.from(Moment.range(startMoment, endMoment).by(key)).map(date =>
    date.format(format),
  );
};

export const generateWeek = (date, events = []) => {
  const day = moment(date);
  const startDate = moment(day.startOf('isoWeek'));
  const endDate = moment(day.endOf('isoWeek'));

  return getRangeOfDates(startDate, endDate).reduce((acum, item) => {
    return { ...acum, [item]: events[item] || [] };
  }, {});
};

export const handleRedirect = url => {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  } else if (url.startsWith('www')) {
    return `http://${url}`;
  }
  return url;
};

export const handleLoadOptions = (query = '', callback) => {
  if (query !== '') {
    return callback();
  }
  return new Promise(resolve => resolve({ options: [] }));
};

export const replaceObjectInArray = (
  data,
  value,
  identificator = '_id',
  valueIdentificator = '_id',
) => {
  return data.map(i => {
    if (i[identificator] === value[valueIdentificator]) {
      return value;
    }
    return i;
  });
};

export const capitalizeFirstletter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatPriceForApi = (price = {}) => {
  return {
    amount: Number(price.amount) || null,
    currency: price.currency || null,
  };
};

export const goBack = async history => {
  if (window.history.length) {
    history.goBack();
  } else {
    history.push('../calendar');
  }
};

export const removeFirmFromUrl = pathName => {
  const url = `/${pathName
    .slice(1)
    .split('/')
    .slice(1)
    .join('/')}`;
  return url;
};

export const getLastPartOfUrl = url => {
  return url.substring(url.lastIndexOf('/') + 1);
};

export const findInRecents = (pathname, recents) => {
  const keys = Object.keys(recents);
  for (let i = 0; i < keys.length; i++) {
    if (pathname.match(keys[i])) {
      return recents[keys[i]];
    }
  }
  return null;
};

export const formatOpportunityStatus = status => {
  switch (status) {
    case 'won':
      return __('Získaná');
    case 'lost':
      return __('Stratená');
    case 'new':
      return __('Nová');
    case 'cancelled':
      return __('Zrušená');
    default:
      return '';
  }
};

export const getIdFromProps = props => {
  if (props.match.params.id) {
    return props.match.params.id;
  }
  return null;
};

export const getPositionLabel = name => {
  if (name === 'crm_user') {
    return __('Obchodný zástupca');
  }
  return name;
};

export const getPercentOf = (x, y) => {
  if (x && y) {
    return ((x / y) * 100).toFixed(3);
  }

  return 0;
};

export const formatPercents = float => {
  if (float) {
    if (float >= 1) {
      return `${Number(float).toFixed()} %`;
    }
    return `${Number(float).toFixed(2)} %`;
  }

  return '0 %';
};

export const roleDecoder = role => {
  return role;
};

export const getYearFromDate = date => {
  const dateObject = new Date(date);
  if (typeof dateObject.getFullYear === 'function') {
    return dateObject.getFullYear();
  }
  return null;
};

export const formatPaymentTerms = terms => {
  if (!terms) {
    return terms;
  }

  if (terms.startsWith('P')) {
    return `${terms.substr(1)} ${__('dní')}`;
  }
  if (terms === 'DOB') {
    return __('Dobierka');
  }
  if (terms === 'HOT') {
    return __('Hotovosť');
  }
  return terms;
};

export const formatActivityType = type => {
  switch (type) {
    case 'call':
      return __('Telefonát');
    case 'mail':
      return __('Email');
    case 'task':
      return __('Email');
    default:
      return __('Stretnutie');
  }
};

export const formatActivityStatus = status => {
  switch (status) {
    case 'waitingOnOthers':
      return __('Čakajúca');
    case 'completed':
      return __('Hotová');
    default:
      return __('Otvorené');
  }
};

export const getAvailableYears = () => {
  const years = [];
  for (let y = 2018; y <= new Date().getFullYear(); y++) {
    years.push(y);
  }
  return years;
};

const PageNavigatorWrapper = styled.div`
  display: none;
  ${({ theme }) => theme.media.m`
  display: block;
`};
`;

const ShortPageNavigatorWrapper = styled.div`
  display: block;
  ${({ theme }) => theme.media.m`
display: none;
`};
`;

export const decodeCountry = code => {
  if (code === 'SK') {
    return __('Slovensko');
  } else if (code === 'CZ') {
    return __('Česká republika');
  }
  return __(code);
};

export const renderPageNavigator = (
  limit,
  offset,
  total,
  onPageClick,
  onDecrease,
  onIncrease,
) => {
  return (
    <React.Fragment>
      <PageNavigatorWrapper>
        <PageNavigator
          activePage={offset / limit + 1}
          end={total / limit + 1}
          onPageClick={page => onPageClick(page)}
          onDecrease={() => onDecrease()}
          onIncrease={() => onIncrease()}
        />
      </PageNavigatorWrapper>
      <ShortPageNavigatorWrapper>
        <ShortPageNavigator
          activePage={offset / limit + 1}
          end={total / limit + 1}
          onPageClick={page => onPageClick(page)}
          onDecrease={() => onDecrease()}
          onIncrease={() => onIncrease()}
        />
      </ShortPageNavigatorWrapper>
    </React.Fragment>
  );
};

export const formatVolume = volume => {
  return `${volume} L`;
};

export const orderStateTrans = state => {
  if (state === 'Released') {
    return __('Potvrdená');
  } else if (state === 'Open') {
    return __('Otvorená');
  }

  return state;
};

export const createCommulativeData = data => {
  const result = data.reduce((acumulator, item, index) => {
    if (index === 0 || item === 0) {
      acumulator.push(item);
    } else {
      acumulator.push(item + acumulator[index - 1]);
    }
    return acumulator;
  }, []);

  return result;
};

export const normalizePlan = plan => {
  if (!plan.length) {
    return {
      plan: [],
      actual: [],
    };
  }
  const actualData = plan.map(item => {
    return item.actual ? item.actual.amount : 0;
  });

  const planData = plan.map(item => {
    return item.plan ? item.plan.amount : 0;
  });

  return {
    plan: createCommulativeData(planData),
    actual: createCommulativeData(actualData),
  };
};

export const translate = (lang, translations, defaultValue) => {
  if (
    translations &&
    translations.find(t => t.lang === lang) &&
    translations.find(t => t.lang === lang).value &&
    translations.find(t => t.lang === lang).value.length > 0
  ) {
    return translations.find(t => t.lang === lang).value;
  }
  return defaultValue;
};

export const translateCodelist = (lang, translations, defaultValue) => {
  if (
    translations &&
    translations.find(t => t.lang === lang) &&
    translations.find(t => t.lang === lang).label &&
    translations.find(t => t.lang === lang).label.length > 0
  ) {
    return translations.find(t => t.lang === lang).label;
  }
  return defaultValue;
};

export const translateAvailability = text => {
  if (text === 'available') {
    return __('Dostupné');
  } else if (text === 'part-available') {
    return __('Čiastočne dostupné');
  } else if (text === 'not-available') {
    return __('Momentálne nedostupné');
  }

  return text;
};

export const getNextWorkDay = (date, days = 1) => {
  if (moment.isMoment(date)) {
    return date.businessAdd(days, 'days');
  }
  return moment(date).businessAdd(days, 'days');
};

export const getOrderDeliveryDate = (time = '11:00') => {
  const m = moment();
  return m.isBefore(moment(time, 'HH:mm'))
    ? getNextWorkDay(m, 1)
    : getNextWorkDay(m, 2);
};

export const translateLayer = layer => {
  if (layer === 0) {
    return __('Impregnácia');
  } else if (layer === 1) {
    return __('1. vrstva');
  } else if (layer === 2) {
    return __('2. vrstva');
  } else if (layer === 3) {
    return __('3. vrstva');
  } else if (layer === 4) {
    return __('4. vrstva');
  }

  return layer;
};

export const formatColorToRGB = color => {
  return `rgb(${color.R},${color.G},${color.B})`;
};

export const invertColor = rgb => {
  const R = 255 - rgb.R;
  const G = 255 - rgb.G;
  const B = 255 - rgb.B;

  return { R, G, B };
};

export const getOrderStatusByCode = c => {
  switch (c) {
    case c === 'Released':
      return 'Uvoľnená';
    case c === 'Pending_Approval':
      return 'Čaká na schválenie';
    case c === 'Pending_Prepayment':
      return 'Čaká na platbu vopred';
    case c === 'Sent':
      return 'Odoslaná';
    default:
      return __('Otvorená');
  }
};

export const formatBytes = (bytes, decimals = 2) => {
  if (typeof bytes !== 'number') {
    return bytes;
  }
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const getColorForBrand = brand => {
  if (brand === 'ANZA') {
    return '#000000';
  } else if (brand === 'BIOCOMP') {
    return '#005b2a';
  } else if (brand === 'CAR-REP') {
    return '#595959';
  } else if (brand === 'DUNAMENTI') {
    return '#2f9f44';
  } else if (brand === 'DURIERU') {
    return '#63b8d4';
  } else if (brand === 'FINKOLORA') {
    return '#d1e19e';
  } else if (brand === 'IRIS') {
    return '#d0cece';
  } else if (brand === 'JEDYNKA') {
    return '#002876';
  } else if (brand === 'KIILTO') {
    return '#32428b';
  } else if (brand === 'MASTON') {
    return '#0059a1';
  } else if (brand === 'MIRKA') {
    return '#fbb929';
  } else if (brand === 'NEOCOLORI') {
    return '#d8a427';
  } else if (brand === 'OWATROL') {
    return '#b40001';
  } else if (brand === 'PIGROL') {
    return '#feed04';
  } else if (brand === 'SHOP') {
    return '#525252';
  } else if (brand === 'TEKNOS IND. METAL') {
    return '#0f4194';
  } else if (brand === 'TEKNOS IND. WOOD') {
    return '#029650';
  } else if (brand === 'TIKKURILA DECO') {
    return '#e20019';
  } else if (brand === 'TIKKURILA IND. FLOOR') {
    return '#aeabab';
  } else if (brand === 'TIKKURILA IND. METAL') {
    return '#0045ad';
  } else if (brand === 'TIKKURILA IND. WOOD') {
    return '#bf9001';
  } else if (brand === 'ZORKA') {
    return '#d1112c';
  } else if (brand === 'INTERNAL ITEMS') {
    return '#8cd609';
  }

  return '#3a3838';
};

export const getColorByReceivablesGroup = group => {
  if (group === 'Pred splatnosťou') {
    return '#009b3f';
  } else if (group === '0-30 dní') {
    return '#8cd609';
  } else if (group === '31-60 dní') {
    return '#fbb929';
  } else if (group === '61-90 dní') {
    return '#bf9001';
  } else if (group === 'nad 90 dní') {
    return '#e20019';
  }

  return '#3a3838';
};

export const translateDueDays = value => {
  if (value === 30) {
    return __('0-30 dní');
  } else if (value === 60) {
    return __('31-60 dní');
  } else if (value === 90) {
    return __('61-90 dní');
  } else if (value === -1) {
    return __('nad 90 dní');
  } else if (value === 0) {
    return __('Pred splatnosťou');
  }

  return value;
};

export const translateSpecialDiscountName = value => {
  if (value === 'quick_pay_discount') {
    return __('Zľava za rýchlu platbu');
  } else if (value === 'own_taking_discount') {
    return __('Zľava za vlastný odber');
  } else if (value === 'pallet_discount') {
    return __('Paletová zľava');
  }

  return value;
};

export const flatten = ary => {
  if (!ary) {
    return [];
  }
  let ret = [];
  for (let i = 0; i < ary.length; i++) {
    if (Array.isArray(ary[i])) {
      ret = ret.concat(flatten(ary[i]));
    } else {
      ret.push(ary[i]);
    }
  }
  return ret;
};

export const translateUserPosition = role => {
  if (role === 'managing_director') {
    return __('Generálny riaditeľ');
  }
  if (role === 'marketing_manager') {
    return __('Marketingový manažér');
  }
  if (role === 'sales_representative') {
    return __('Obchodný zástupca');
  }
  if (role === 'sales_director') {
    return __('Obchodný riaditeľ');
  }
  if (role === 'sales_manager') {
    return __('Manažér predaja');
  }
  if (role === 'sales_assistant') {
    return __('Asisten predaja');
  }
  if (role === 'service_technician') {
    return __('Servisný technik');
  }
  if (role === 'service_technician') {
    return __('Aplikačný technik');
  }
  if (role === 'logistic_manager') {
    return __('Manažér logistiky');
  }
  if (role === 'it_manager') {
    return __('IT manažér');
  }
  if (role === 'marketing_assistant') {
    return __('Asisten marketingu');
  }

  if (role === 'customer') {
    return __('Zákazník');
  }

  return role;
};

export const getServiceStatus = service => {
  if (service.status === 'closed') {
    return __('Uzavretá');
  }

  if (!service.solver_id) {
    return __('Nová');
  }

  return __('V riešení');
};
const Bold = styled.b`
  font-weight: ${props => props.weight};
`;

const Normal = styled.b`
  font-weight: ${props => props.weight};
`;

export const getHighlightedText = (
  text,
  highlight,
  normalWeight = 400,
  highlightedWeight = 800,
) => {
  // Split text on highlight term, include term itself into parts, ignore case

  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

  return (
    <span>
      {parts.map(part =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <Bold weight={highlightedWeight}>{part}</Bold>
        ) : (
          <Normal weight={normalWeight}>{part}</Normal>
        ),
      )}
    </span>
  );
};

export const translateCartTitle = title => {
  if (title === 'cart1') {
    return __('Moja objednávka');
  }

  if (title === 'android') {
    return __('Mobilna aplikácia');
  }

  return __(title);
};



// WEBPACK FOOTER //
// ./src/Utils/index.js